module.exports = __webpack_public_path__ + "img/bg.c688c60a.png";